import React, { useContext } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from 'react-bootstrap';
import { AppContext } from '../store';
import { UITypes } from '../store/actions';


const ResourceToggle = () => {
    const { state, dispatch } = useContext(AppContext);
    const handleChange = () => {
        dispatch({
            type: UITypes.setUI,
            payload: { ...state, drawer_expanded: !state.uiInfo.drawer_expanded },
        });
    }
    return <div className="me-3 d-none d-lg-block">
        <Button variant="light" onClick={handleChange}>
            {state.uiInfo.drawer_expanded ? <FontAwesomeIcon icon="times" /> : <FontAwesomeIcon icon="bars" />}
        </Button>
    </div>;
};

export default ResourceToggle;
